import { c as _c } from "react/compiler-runtime";
/**
  * Do not edit this file manually.
  * It is automatically generated.
  * Run `npm run svg:convert` to regenerate.
  */
import type React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
export default function FaqLargeIcon(props) {
  const $ = _c(5);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      maskType: "alpha"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <mask id="mask0_12371_103068" style={t0} maskUnits="userSpaceOnUse" x="0" y="0" width="40" height="40"><rect width="40" height="40" /></mask>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <g mask="url(#mask0_12371_103068)"><path d="M20.2513 28.125C20.6949 28.125 21.0694 27.9718 21.375 27.6654C21.6806 27.359 21.8333 26.984 21.8333 26.5404C21.8333 26.0968 21.6801 25.7222 21.3737 25.4167C21.0674 25.1111 20.6924 24.9583 20.2487 24.9583C19.8051 24.9583 19.4306 25.1115 19.125 25.4179C18.8194 25.7243 18.6667 26.0993 18.6667 26.5429C18.6667 26.9865 18.8199 27.3611 19.1262 27.6667C19.4326 27.9722 19.8076 28.125 20.2513 28.125ZM18.875 21.9583H21.25C21.25 21.5417 21.2778 21.1736 21.3333 20.8542C21.3889 20.5347 21.4861 20.2222 21.625 19.9167C21.7639 19.6111 21.9583 19.3056 22.2083 19C22.4583 18.6945 22.7658 18.3592 23.1308 17.9942C24.0436 17.0814 24.6806 16.2708 25.0417 15.5625C25.4028 14.8542 25.5833 14.1111 25.5833 13.3333C25.5833 11.8611 25.1111 10.6945 24.1667 9.83334C23.2222 8.97223 21.9511 8.54168 20.3533 8.54168C18.9125 8.54168 17.6879 8.88195 16.6796 9.56251C15.671 10.2431 14.9306 11.1806 14.4583 12.375L16.6667 13.2917C17.0556 12.5139 17.5583 11.9236 18.175 11.5208C18.7917 11.1181 19.5111 10.9167 20.3333 10.9167C21.2222 10.9167 21.9236 11.1389 22.4375 11.5833C22.9514 12.0278 23.2083 12.6403 23.2083 13.4208C23.2083 13.9736 23.0556 14.507 22.75 15.0208C22.4444 15.5347 21.9306 16.1457 21.2083 16.8538C20.7361 17.2846 20.3542 17.6786 20.0625 18.0358C19.7708 18.3928 19.5278 18.7697 19.3333 19.1667C19.1689 19.5658 19.0514 19.9851 18.9808 20.4246C18.9103 20.8638 18.875 21.375 18.875 21.9583ZM20 38.3333L15 33.3333H7.5C6.83333 33.3333 6.25 33.0764 5.75 32.5625C5.25 32.0486 5 31.4722 5 30.8333V5.83334C5 5.16668 5.25 4.58334 5.75 4.08334C6.25 3.58334 6.83333 3.33334 7.5 3.33334H32.5C33.1389 3.33334 33.7153 3.58334 34.2292 4.08334C34.7431 4.58334 35 5.16668 35 5.83334V30.8333C35 31.4722 34.7431 32.0486 34.2292 32.5625C33.7153 33.0764 33.1389 33.3333 32.5 33.3333H25L20 38.3333ZM7.5 30.8333H16L20 34.8333L24 30.8333H32.5V5.83334H7.5V30.8333Z" /></g>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== props) {
    t3 = <SvgIcon {...props}>{t1}{t2}</SvgIcon>;
    $[3] = props;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}